import moment from "moment";

export function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

export function dateFormat(date, type) {
  switch (type) {
    case 1:
      return moment(date).locale("ja").format("YYYY-MM-DD (ddd) HH:mm");

    case 2:
      return moment(date).locale("ja").format("YYYY-MM-DD");

    case 3:
      return moment(date).locale("ja").format("YYYY-MM");

    default:
      return;
  }
}

export function formatAttendanceDate({
  attendance_date,
  regular_class_schedule,
}) {
  return dateFormat(
    `${attendance_date} ${regular_class_schedule.start_time}`,
    1
  );
}

export function getWeekOfMonth(dateStr) {
  return Math.ceil(moment(dateStr).date() / 7);
}

export function parseBusTime(time) {
  return moment(time, "HH:mm:ss");
}

export const getJpWeekDay = date => {
  const weekDay = moment(date).day();
  const weekdays = ["日", "月", "火", "水", "木", "金", "土"];

  return weekdays[weekDay];
};
